var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExtraReportLightBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04abc1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    className: "cls-1",
    d: "M18.43,10.75c-.62,0-1.13-.51-1.13-1.13,0,0,0,0,0,0V3.22H7.93c-.62,0-1.12.5-1.12,1.12v21.77c-.03.62.45,1.14,1.07,1.16h15.78c.62,0,1.12-.5,1.12-1.12h0v-15.41h-6.35ZM20.29,20.68c0,.31-.25.56-.56.56h-7.87c-.31,0-.56-.25-.56-.56v-.37c0-.31.25-.56.56-.56h7.87c.31,0,.56.25.56.56v.37ZM20.29,17.68c0,.31-.25.56-.56.56h-7.87c-.31,0-.56-.25-.56-.56h0v-.37c0-.31.25-.56.56-.56h7.87c.31,0,.56.25.56.56h0v.37ZM20.29,14.68c0,.31-.25.56-.56.56h-7.87c-.31,0-.56-.25-.56-.56h0v-.36c0-.31.25-.56.56-.56h7.87c.31,0,.56.25.56.56h0v.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    className: "cls-1",
    d: "M24.8,8.96v.29h-6V3.22h.29c.3,0,.59.12.8.32l4.63,4.63c.2.22.3.5.29.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtraReportLightBlue);
export default __webpack_public_path__ + "static/media/Extra Report - Light Blue.f36254e718430ff0ccad0f0e6d58ee19.svg";
export { ForwardRef as ReactComponent };